<template>
    <div class="mx-2  pt-2 py-2" style="background-color: #F9F9F9; height: 90vh;">
        <h1 class="flex justify-center text-2xl 100vh  mb-5 pt-10 ">Update City</h1>
        <form class="max-w-md mx-auto" @submit.prevent="submit">
            <div class="mb-5">
                <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Name</label>
                <input type="text" v-model="name" id="username"
                    class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                    placeholder=" Name" required />
            </div>
            <div class="mb-5">
                <label for="number" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Code</label>
                <input type="text" v-model="code" @input="validateCode" id="username"
                    class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                    placeholder="Code" required />
                <div v-if="codeValidationError" class="text-red-500 text-sm mt-1">
                    {{ codeValidationError }}
                </div>
            </div>
            <!-- <div class="mb-5">
                <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    City</label>
                <select id="countries" v-model="distric_id" placeholder="City"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option selected value="0">Choose a City</option>
                    <option v-for="site in city" :key="site.id" :value="site.id">{{ site.name }}
                    </option>
                </select>
            </div> -->
            <div class="flex items-center">
                    <label class="relative flex items-center mb-5 cursor-pointer">
                        <input type="checkbox" v-model="is_active" value="" class="sr-only peer">
                        <div
                            class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
                        </div>
                        <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Active</span>
                    </label>
                </div>
            <div class="flex items-center mt-5 justify-center">
                <router-link to="city"
                    class="text-white mb-5  bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Back</router-link>
                <button type="submit" :disabled="isdisabled" :class="{ 'bg-gray-500 ': isdisabled }"
                    class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Update  City</button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUpdated } from 'vue';
import Swal from 'sweetalert2';
import axiosInstce from "@/plugins/axios"
import { useRouter } from 'vue-router';

const router = useRouter(); // Initialize the router object

const distric_id = ref()
const city = ref([])
const name = ref()
const code = ref()
const codeValidationError = ref('');
const is_active = ref()
const tehsisID =ref()
const isdisabled = ref(false)
const validateCode = () => {
    const codeAsString = code.value.toString();

    // Check if the code is exactly 2 digits long
    if (codeAsString.length !== 2) {
        isdisabled.value = true;
        codeValidationError.value = 'Code must be exactly 2 digits long.';
    } else {
        // Check if the code is a number (optional)
        const isNumeric = /^\d+$/.test(codeAsString);

        if (!isNumeric) {
            isdisabled.value = true;
            codeValidationError.value = 'Code must be a numeric value.';
        } else {
            isdisabled.value = false;
            codeValidationError.value = '';
        }
    }
};

const getDistrictById = () => {
    axiosInstce.get(`/district/${tehsisID.value}`)
        .then(response => {
            // city.value = response.data.data.data
            code.value = response?.data?.data?.district?.code,
            name.value = response?.data?.data?.district?.name,
            // distric_id.value = response?.data?.data?.district?.district?.id,
            is_active.value = response?.data?.data?.district?.is_active
        })
        .catch(error => {
            console.error('Error fetching district:', error);
        });
}

const submit = async () => {
    try {
        const response = await axiosInstce.put(`/districts/${tehsisID.value}`, {
            name: name.value,
            code: code.value,
            // district_id:distric_id.value,
            is_active: is_active.value === true ? 1 : 0,
        });
        Swal.fire({
            toast: true,
            title: 'City Update successfully.',
            icon: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        router.push({ name: 'city' });
    } catch (error) {
        console.error('Error fetching city info:', error);
        Swal.fire({
            toast: true,
            title: error.response.data.message,
            icon: 'error',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
    }
    // form.value = '';

};
onMounted(() => {
    const id = router.currentRoute.value.params.id;
    tehsisID.value = id
    getDistrictById()
})
</script>